import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about">
      <div className="aboutCard">
        <h1>About Us</h1>
        <span>
          "Welcome to our Food Delivery App - your ultimate destination for
          delicious meals delivered right to your doorstep! With a wide variety
          of cuisines and partner restaurants, we are here to satisfy all your
          cravings. Our mission is to provide you with a seamless, convenient,
          and safe food delivery experience. At Food Delivery, we prioritize
          quality and safety, ensuring that every meal is prepared with care and
          delivered promptly. Our team is dedicated to delivering smiles along
          with every order, and your satisfaction is our top priority. As a
          community-driven platform, we are proud to support local restaurants
          and give back to the neighborhoods we serve. Together, we can make a
          positive impact and celebrate the diversity of flavors. Transparency
          is the backbone of our operations. We maintain open communication with
          our users, from order updates to feedback collection. Your valuable
          insights help us continually improve and offer you the best possible
          service. Our talented team of food enthusiasts works tirelessly to
          bring you exciting new features and special offers. Keep an eye out
          for exclusive discounts, loyalty rewards, and other surprises that
          make ordering from us a treat every time. Join our food-loving
          community today and embark on a journey of culinary delights. Download
          now and experience the joy of food delivery reimagined!"
        </span>
      </div>
    </div>
  );
};

export default About;
